import { Component, OnDestroy, OnInit } from '@angular/core';
import { from, Subject } from 'rxjs';
import { addTrailingSlash, removeTrailingSlash } from '@classifieds-sell/shared';
import { UserFacade } from '@classifieds-sell/state';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'apps/motors-sell/src/environments/environment';

@Component({
    selector: 'motors-header',
    templateUrl: './motors-header.component.html'
})
export class MotorsHeaderComponent implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    tradeMeUrl = `${removeTrailingSlash(environment.trademeUrl)}`;
    myTradeMeUrl = `${addTrailingSlash(
      environment.trademeUrl
    )}MyTradeMe/Default.aspx`;
    myPhotoUrl: string;

    constructor(private _userFacade: UserFacade) {}

    ngOnDestroy(): void {
      this._destroyed$.next();
    }

    ngOnInit(): void {
      from(this._userFacade.userDetails$)
        .pipe(takeUntil(this._destroyed$))
        .subscribe((ud) => {
          this.myPhotoUrl =
            ud.memberSummary?.memberProfile?.photo ||
            'assets/trademe-core-ui/kiwi130-v2.gif';
        });
    }
}
